/**
 * Ключи в глобальном объекте Window (браузер)
 */
export const WINDOW_MANIFEST_CONST = '_cianMfRegistryManifest' satisfies keyof Window;
export const WINDOW_REGISTRY_CONST = '_cianMfRegistry' satisfies keyof Window;
export const WINDOW_ASSETS_STORAGE_CONST = '_cianAssetsStorage' satisfies keyof Window;

/**
 * Имена атрибутов Web Компонента для создания экземпляров UI Runtime
 */
export const ATTRIBUTE_MICROFRONTEND_NAME = 'name';
export const ATTRIBUTE_IMAGE_VERSION = 'image';
export const ATTRIBUTE_RUNTIME_NAME = 'runtime';
export const ATTRIBUTE_INSTANCE_ID = 'instance';
export const ATTRIBUTE_PARAMETERS = 'parameters';
